import { render } from "./Solution.vue?vue&type=template&id=91ece764&scoped=true"
const script = {}

import "./Solution.vue?vue&type=style&index=0&id=91ece764&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91ece764"]])

export default __exports__